import React from "react";
import { Box } from "@mui/material";
import TitleBar from "../../components/navbar/TitleBar";
import SchoolBusNavMenu from "../../components/createForm/SchoolBusNavMenu";
import Footer from "../../components/common/Footer";
import Stops from "../../components/stops/Stops";

export default function SchoolBusStops() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        minHeight: "100vh",
      }}
    >
      <Box>
        <TitleBar />
        <SchoolBusNavMenu />
        <Stops variant="school" />
      </Box>
      <Footer />
    </Box>
  );
}
